import React, { useEffect, useRef } from 'react';
import { HiMenu } from 'react-icons/hi';
import './Header.css';

const Header = ({ onMenuToggle }) => {
  const headerRef = useRef(null);


  return (
    <header className="header" ref={headerRef}>
      <button 
        className="menu-button"
        onClick={onMenuToggle}
        aria-label="Open menu"
      >
        <HiMenu size={22} />
      </button>
      
      <h1 className="header-title">
        ANGELIKA ERTA
      </h1>

    </header>
  );
};

export default Header;